// Vendor libraries...
import $ from 'jquery'
import 'bootstrap';

import * as trainPairing from './train-app-pairing';
import * as smartClub from './smart-club';

// Export jquery for others scripts to use outside of packaged js app...
window.$ = $;
window.jQuery = $;
window.jQuery.migrateMute = true;

(function ($) {
    "use strict";
    if(location.pathname == "/unsubscribe/") {
        console.log("unsubscribe hook loaded")

        $(".btn-unsub-sms").click(function() {
            $(".unsub-options").hide();
            $(".email-group").hide();
            $(".unsub-inputs").show();
        });

        $(".btn-unsub-email").click(function() {
            $(".unsub-options").hide();
            $(".phone-number-group").hide();
            $(".unsub-inputs").show();
        });

        $('#global-unsubscribe').submit(function(e) {
          //prevent the form from submiting so we can post to the google form
          e.preventDefault();
          //AJAX request
          $.ajax({
            //url: 'https://docs.google.com/forms/d/e/1FAIpQLSdUs-5xB1rc5-5xqlTtkKogSboNutEZKQhQKv5jRMwYG0m5eA/formResponse',
            url: 'https://store.12rndubx.com/store/forms/d/e/1FAIpQLSdUs-5xB1rc5-5xqlTtkKogSboNutEZKQhQKv5jRMwYG0m5eA/formResponse',
            data: $('#global-unsubscribe').serialize(), //Nifty jquery function that gets all the input data
            type: 'POST', //tells ajax to post the data to the url
            dataType: "json", //the standard data type for most ajax requests
            statusCode: { //the status code from the POST request
              0: function(data) { //0 is when Google gives a CORS error, don't worry it went through
                //success
                $(".unsub-form").hide();
                $('.form-success').show();
              },
              200: function(data) {//200 is a success code. it went through!
                //success
                $(".unsub-form").hide();
                $('.form-success').show();
              },
              403: function(data) {//403 is when something went wrong and the submission didn't go through
                //error
                alert('Oh no! something went wrong. Please try again later');
              }
            }
          });
        });
    }

    if(location.pathname == "/find-a-club/" || location.pathname == "/apps-terms-conditions/") {
        $.getJSON(`${process.env.UBX_TRAINING_URL}/api/v1/geo/ip`, function(data) {
            // JSON result in `data` variable
            var countryCode = data.clientInformation.source_country || 'XX';

            switch (countryCode) {
                //case "AU":
                //    if(location.pathname == "/find-a-club/") window.location = "https://12rnd.com.au/find-a-club.html";
                //    if(location.pathname == "/apps-terms-conditions/") window.location = `${process.env.UBX_TRAINING_URL}/legal/terms-and-conditions-apps.html`;
                //    break;
                default:
                    if(location.pathname == "/find-a-club/") window.location = `${process.env.UBX_TRAINING_URL}/find-a-club.html`;
                    if(location.pathname == "/apps-terms-conditions/") window.location = `${process.env.UBX_TRAINING_URL}/legal/terms-and-conditions-app`;
                    break;
            }
        })
        .fail(function() {
            window.location = `${process.env.UBX_TRAINING_URL}/find-a-club.html`;
        });
    }

    if(location.pathname == "/p/") {
        trainPairing.detectPairingCode();
    }
    if(location.pathname == "/ph/tv/") {
        smartClub.pairCoachingScreen();
    }
    if(location.pathname == "/ph/cctv/") {
        smartClub.pairCCTV();
    }
    if(location.pathname == "/ph/duress/") {
        smartClub.pairDuress();
    }
    
})($);